<template>
    <div>
      <job-status-list></job-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  